<div class="main-wrapper">
  <div class="header-wrapper">
    <header *ngIf="headerMenushowHide">
      <app-header-search-bar></app-header-search-bar>
    </header>
    <main>
      <router-outlet>
      </router-outlet>
    </main>
  </div>
</div>